import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { selectLowFees, selectHighFees } from '../../../store/selectors/home/equity/equity'
import { Format } from '../..'

const FeeRange = () => {
  const lowFees = useSelector(selectLowFees)
  const highFees = useSelector(selectHighFees)

  return (
    <FormattedMessage
      id='Homeowner.purchasePower.feeRange'
      defaultMessage="Remember you'll pay something like {low} to {high} in fees and commissions when you sell your current home. This cost varies by agent, location, and company"
      values={{
        low: <Format.Currency abbreviate value={lowFees} />,
        high: <Format.Currency abbreviate value={highFees} />
      }}
    />
  )
}

export default FeeRange
